<template>
    <div class="table-responsive">
        <table class="table table-striped table-hover">
            <thead>
                <tr>
                    <th>Date</th>
                    <th>Type</th>
                    <th>Submit URL</th>
                    <th>Sent to Employers</th>
                    <th>Campaign</th>
                    <th>Job</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(a, index) in applications" :key="index">
                    <td style="width: 15%">{{ a.date }}</td>
                    <td style="width: 10%">{{ a.app_type }}</td>
                    <td>{{ a.app_submit_page }}</td>
                    <td>{{ a.employers }}</td>
                    <td>{{ a.campaign }}</td>
                    <td>
                        <template v-if="a.job_id">
                            job 
                            <a :href="url(`admin/jobs/${a.job_id}`)">
                                {{ a.job_id }}
                            </a>
                        </template>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: [
        'applications',
    ],
}
</script>